import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

declare global {
  interface Window {
    grecaptcha: any;
    recaptchaSiteKey: string;
  }
}

@Injectable({
  providedIn: 'root'
})
export class RecaptchaV3Service {
  private siteKey: string = this.getgCaptchaV3SiteKey();
  private grecaptchaLoaded: Promise<any> | null = null;

  constructor() { }

  /** Load reCAPTCHA v3 script dynamically */
  loadRecaptchaV3(): Promise<any> {
    if (this.grecaptchaLoaded) {
      return this.grecaptchaLoaded;
    }

    this.grecaptchaLoaded = new Promise((resolve, reject) => {
      if (window.grecaptcha) {
        resolve(window.grecaptcha);
        return;
      }

      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(this.siteKey)}`;
      script.async = true;
      script.defer = true;

      script.onload = () => resolve(window.grecaptcha);
      script.onerror = () => reject(new Error('Failed to load reCAPTCHA script'));

      document.head.appendChild(script);
    });

    return this.grecaptchaLoaded;
  }

  /** Get a reCAPTCHA v3 token */
  async getRecaptchaV3Token(): Promise<string | null> {
    //await this.loadRecaptchaV3();

    const pathname = window.location.pathname.replace(/\/+$/, '');
    let formName = pathname.split('/').pop() || null;
    if (formName) {
      formName = formName.replace(/[^a-zA-Z0-9]+/g, '_');
    }

    let maxRetries = 5;
    let attempts = 0;

    return new Promise<string | null>((resolve) => {
      const executeRecaptcha = async () => {
        try {
          await new Promise<void>((ready) => window.grecaptcha.ready(ready));

          const token = await window.grecaptcha.execute(this.siteKey, { action: formName });

          if (!token) {
            console.warn('Empty token received');
          }

         resolve(token);
        } catch (err) {
          attempts++;
          console.warn(`reCAPTCHA attempt ${attempts} failed:`, err);

          if (attempts < maxRetries) {
            setTimeout(executeRecaptcha, 1000);
          } else {
            console.warn('Failed to generate reCAPTCHA token after multiple attempts');
            resolve(null);
          }
        }
      };

      executeRecaptcha();
    });
  }
  public getgCaptchaV3SiteKey(): string {
    return window.location.href.toLowerCase().indexOf("mofastg.mofaic") > -1 ? environment.RecaptchaV3SiteStgKey : environment.RecaptchaV3SitePrdKey;
  }
  async ProcessRecaptchaV3(): Promise<string>  {
    try {
      return await this.getRecaptchaV3Token();
      //console.log('reCAPTCHA token:', this.recaptchaV3Token);
    } catch (err) {
      console.error('reCAPTCHA failed:', err);
    }

  }

  getToken(): Promise<string | null> {
    const pathname = window.location.pathname.replace(/\/+$/, '');
    let formName = pathname.split('/').pop() || null;
    if (formName) {
      formName = formName.replace(/[^a-zA-Z0-9]+/g, '_');
    }
    return window.grecaptcha.execute(this.siteKey, { action: formName });
  }
}
